import {
  ImageProps as MantineImageProps,
  Image as MantineImage,
} from '@mantine/core';

export type ImageProps = MantineImageProps;

export const Image = MantineImage as typeof MantineImage;

Image.displayName = 'Image';
